import React from 'react'

import { InputBlurWithCTA_RHF } from '@ui/components/InputBlurRHF'
import ModalRoot from '@ui/components/ModalRoot'

import { useForm } from 'react-hook-form'
import * as yup from 'yup'
import chiudi from '@assets/Ico_chiudi_verde.png'
import { _useSaveDataForm } from './simulatore-hooks'
import { formDataAtom, ModuleType } from '@store/store'
import { useAtom } from 'jotai'
import { yupResolver } from '@hookform/resolvers/yup'
import { ERROR_TEMPLATES, regexEmail } from '@utils/validators'
import { useNavigate } from 'react-router-dom'


type ModalProps = {
	isModalOpen: boolean
	closeModal: () => void
	tipo: number
	action: number
}

type ExitModalFormValues = {
	email?: string
}

export const ExitModal = ({
	isModalOpen,
	closeModal,
	tipo = ModuleType.SIMULATORE, //1 SIMULATORE 2- RICHIESTA
	action = 1, //1 SALVA  2- ESCI
}: ModalProps) => {
	const navigate = useNavigate()

	const anagrafica = yup.object<ExitModalFormValues>({
		email: yup
			.string()
			.test('email-optional', ERROR_TEMPLATES.invalidEmail, (value) => {
				if (!value || value.trim() === '') return true
				return regexEmail.test(value)
			})
	})

	const {
		control,
		handleSubmit,
		watch,
		trigger,
		setValue,
		clearErrors,
		//formState: { errors, isValid },
	} = useForm<ExitModalFormValues>({
		mode: 'onBlur',
		reValidateMode: 'onBlur',
		resolver: yupResolver(anagrafica),
		defaultValues: {
			email: '',
		},
	})

	const emailValue = watch('email') ?? ''

	const isEmailInvalid =
		emailValue.trim() !== '' && !regexEmail.test(emailValue)

	const url =
		tipo === 1 ? 'DbOperations/SalvaOffertaSim' : 'DbOperations/SalvaOffertaSim'

	const [, setFormData] = useAtom(formDataAtom)
	const {
		data: savedData,
		fetchData: saveDataForm,
		loadingData,
	} = _useSaveDataForm(url)

	const onCallBack = handleSubmit((data) => {

		setFormData((prev) => ({
			...prev,
			 email: data.email?.trim() || null,
		}))

		saveDataForm(data.email)
	})

	const exitUrl = import.meta.env.VITE_EXIT_URL

	React.useEffect(() => {
		if (!savedData) return

		{
			closeModal()
			window.location.href = exitUrl
		}
	}, [savedData])

	const onExit = () => {
		closeModal()
	 window.location.href = exitUrl
	}

	React.useEffect(() => {
		if (!emailValue || emailValue.trim() === '') {
			clearErrors('email')
		}
	}, [emailValue, clearErrors])

	return (
		<>		
	
		<ModalRoot
			isOpen={isModalOpen}
			onCloseModal={closeModal}
			title={'Sei sicuro di voler uscire?'}
			onCallBack={!emailValue?.trim() ? onExit : onCallBack}
			labelOk={'No, continua la simulazione'}
			labelClose={'Si, esci e torna all’homepage'}
			disableButton={false}
			disableButtonAdd={isEmailInvalid || loadingData}
			reverseButton={true}
			loading={loadingData}
			height="h-[570px] md:h-[480px] lg:h-[450px]"
			width="max-w-[370px] md:max-w-[720px] lg:max-w-[980px]"
		>
			
				{action === 1 ? (
				<div className='text-lg md:text-[16px] font-medium'>
					Se vuoi, puoi inserire la tua email per riprendere più tardi: ti
					invieremo un link per continuare da dove hai lasciato.{' '}
					<br></br>
					Approfondisci le modalità di trattamento dei dati da parte di BCC
					CreditoConsumo leggendo l'informativa privacy completa scaricabile
					nella sezione Privacy del sito Crediper.it
				</div>
			) : (
				<div>
					<div className='font-medium text-[18px] pb-2.5'>
						Ti manca pochissimo per completare la tua richiesta.
					</div>
					<div className='font-[400px] text-[16px]'>
						Se vuoi, puoi inserire la tua email per riprendere più tardi: ti
						invieremo un link per continuare da dove hai lasciato.{' '}
						<br></br>
						Approfondisci le modalità di trattamento dei dati da parte di BCC
						CreditoConsumo leggendo l'informativa privacy completa scaricabile
						nella sezione Privacy del sito Crediper.it
					</div>
				</div>
			)}

			<InputBlurWithCTA_RHF
				label='Email'
				name='email'
				type='email'
				control={control}
				validateOnlyOnBlur
				normalizeOnBlur={(value) => value.trim().replace(/\s+/g, '')}
				trigger={trigger}
				setValue={setValue}
				clearErrors={clearErrors}
				renderCTA={({ clear }) => (
					<button type='button' className='cta-base' onClick={clear} aria-label='Cancella email'>
						<img src={chiudi} className='w-4 h-4' alt='' />
					</button>
				)}
			/>
			
			
		</ModalRoot>
		</>

	)
}
